import * as React from "react";

import useCurrentUser from "@v2/hooks/useCurrentUser";
import { useDocumentTitle } from "@v2/hooks/useDocumentTitle";
import { Navigate, useLocation, useSearchParams } from "react-router-dom";

const AuthenticatedUserRequiredRoute: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { isAuthenticated, isLoading } = useCurrentUser();
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const isEditorRoute = pathname.startsWith("/editor/");

  // Set "Dashboard" title for non-editor routes (editor routes set their own title)
  useDocumentTitle(isEditorRoute ? null : "Dashboard");

  if (!isAuthenticated && !isLoading) {
    return (
      <Navigate
        to={`/auth/signup?next=${pathname}&${searchParams.toString()}`}
        replace
      />
    );
  }

  return <>{children}</>;
};

export default AuthenticatedUserRequiredRoute;
